/* eslint-disable react-hooks/exhaustive-deps */
import { FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { database, auth } from "../../firebase";
import { get, ref } from "firebase/database";
import companyLogo from "../../companylogo.png";
import { FiMenu } from "react-icons/fi";
import { LuLogOut } from "react-icons/lu";

const AdminHeader = ({ user, isSidebarOpen, setIsSidebarOpen }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const [headerMessage, setHeaderMessage] = useState(""); // Message to display in header
  const [companyLogoUrl, setCompanyLogoUrl] = useState(companyLogo);
  const [companyName, setCompanyName] = useState("");
  
  // Fetch user and company data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userId = user?.uid;
        if (!userId) return;

        // Fetch user info
        const userRef = ref(database, `users/${userId}`);
        const snapshot = await get(userRef);

        if (snapshot.exists()) {
          const userData = snapshot.val();
          const companyId = userData.companyId;
          fetchCompany(companyId);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        console.log("Sccesss");
      }
    };

    fetchData();
  }, [user]);

  const fetchCompany = async (companyId) => {
    try {
      if (!companyId) return;
      const companyRef = ref(database, `companies/${companyId}`);
      const snapshot = await get(companyRef);

      if (snapshot.exists()) {
        const companyData = snapshot.val();
        setCompanyLogoUrl(companyData.logo || companyLogo);
        setCompanyName(companyData.companyName || "Company Name");
        // Calculate expiration status and set messages
        const expiredAt = companyData.expiredAt;
        getExpirationMessage(expiredAt);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const getExpirationMessage = (expiredAt) => {
    const expiredDate = new Date(expiredAt);
    const currentDate = new Date();
    const timeDifference = expiredDate - currentDate;
    const daysDifference = timeDifference / (1000 * 3600 * 24);

    if (daysDifference <= 0) {    
      setHeaderMessage("Company Expired");
      return;
    } else if (daysDifference <= 3) {
      setHeaderMessage("Company Expiring Soon");
      return;
    } else {
      return; // If more than 3 days from expiration
    }
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      localStorage.removeItem("userUID");
      localStorage.removeItem("userId");
      navigate("/login");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleMenuClick = () => {
    setIsSidebarOpen(true); // Open sidebar
  };

  // Close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest(".dropdown-menu") === null && event.target.closest(".dropdown-button") === null) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <header className="bg-white text-black py-4 shadow-sm border-b-2">
      <div className="flex justify-between items-center px-4 sm:px-6">
        <button
          className="lg:hidden bg-white text-black p-2 rounded-md focus:outline-none"
          onClick={handleMenuClick}
        >
          <FiMenu className="w-6 h-6" />
        </button>
        <div>
          <img
            src={companyLogoUrl} // Base64 or URL logo
            alt={`Company logo for ${companyName}`}
            className="h-10 sm:h-12 max-h-12"
          />
        </div>
        {/* Expiration Message */}
        {headerMessage && (
          <div className="text-red-500 text-sm ml-4">
            {headerMessage} {/* Display expiration message */}
          </div>
        )}
        {/* User Icon and Dropdown */}
        <div className="relative">
          <button
            className="dropdown-button flex items-center gap-2 focus:outline-none"
            onClick={toggleDropdown}
          >
            <span className="text-sm font-medium">Admin</span>
            <div className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full">
              <FiUser size={20} />
            </div>
          </button>
          {isDropdownOpen && (
            <div
              className="dropdown-menu absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg py-2 text-gray-800 z-50"
            >
              <button
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                onClick={() => navigate("/change-password")}
              >
                Change Password
              </button>
              <button
                className="text-black px-4 py-2 hover:bg-gray-100 flex items-center space-x-2 w-full"
                onClick={handleLogout}
              >
                <LuLogOut />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
